import React from 'react';
import './StripePoweredBy.scss';
import { LoadingIndicator } from 'src/latest/src';
import { useTranslation } from 'react-i18next';

interface StripePoweredByProps {
  buttonLabel: string;
  handleSubmit?: (event: React.FormEvent) => void;
  fromView?: boolean;
  processing?: boolean;
  disabled?: boolean;
  isFromOnboarding?: boolean;
}

const StripePoweredBy: React.FC<StripePoweredByProps> = ({
  handleSubmit,
  buttonLabel,
  fromView = false,
  processing = false,
  disabled = false,
  isFromOnboarding = false,
}) => {
  const { t } = useTranslation('stripePayment');

  return (
    <div
      className={`form-actions stripe-card-submit ${
        fromView ? 'from-view' : ''
      }`}
    >
      <div>
        {!isFromOnboarding && (
          <>
            {processing ? (
              <div className="d-flex justify-content-center">
                <LoadingIndicator loading={processing} />
              </div>
            ) : (
              <div>
                <button
                  type={handleSubmit ? 'button' : 'submit'}
                  onClick={handleSubmit}
                  className={`stripe-card-submit-button ${
                    disabled ? 'stripe-card-submit-button-disabled' : ''
                  }`}
                  disabled={disabled}
                >
                  {buttonLabel}
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <div className="stripe-card-submit-powered-by">
        <p className="stripe-card-submit-powered-by-text">
          {t('stripePoweredBy.text.poweredBy')} <b>Stripe</b>
        </p>
      </div>
    </div>
  );
};

export default StripePoweredBy;
